import store from "@/store";
import request from "@/utils/request";

export async function postSsoAdmLogin(params) {
    console.log("@@ post : postSsoLogin");
    let result = request.post("/api/sso/ssoAdm/login",params);
    return result;
}

export async function postSmsAuthCode(params) {
    console.log("@@ post : smsAuthCode");
    let result = request.post("/api/sso/ssoAdm/smsAuthCode",params);
    return result;
}

//관리자 목록
export async function getSsoAdmList(params) {
    console.log("@@ get list : getSsoAdmList");
    let result = request.get("/api/sso/ssoAdm/",{params});
    return result;
}

//관리자 상세
export async function getSsoAdmItem(adminSeq) {
    console.log("@@ get item : getSsoAdmItem");
    let result = request.get(`/api/sso/ssoAdm/detail/${adminSeq}`);
    return result;
}

//관리자 상세 By Id
export async function getSsoAdmItemById(adminId) {
    console.log("@@ get item : getSsoAdmItemById");
    let result = request.get(`/api/sso/ssoAdm/detailById/${adminId}`);
    return result;
}

//관리자 아이디 중복 체크
export async function isAdmExistById(adminId) {
    console.log("@@ get item : isAdmExistById", adminId);
    let result = request.get(`/api/sso/ssoAdm/isExistById?adminId=${adminId}`);
    return result;
}

//권한 목록
export async function getSsoRoleList(params) {
        console.log("@@ get list : getSsoRoleList");
        let result = request.get("/api/sso/ssoRole/",{params});
        return result;
    }

export async function saveSsoAdm(params) {
    console.log("@@ post save : saveSsoAdm");
    let result = request.post(`/api/sso/ssoAdm/`,params);
    return result;
}

export async function deleteSsoAdm(params) {
    console.log("@@ delete : deleteSsoAdm");
    let result = request.delete(`/api/sso/ssoAdm/${params.adminSeq}`,{params});
    return result;
}
